module.exports = __webpack_public_path__ + "media/images/icons/material/globe-8f085ec00b90e0aeab74a42669da0221.svg";